export const ErrEmailAlreadyExists = new Error('user with this email already exists');

export const ErrPhoneAlreadyExists = new Error('user with this phone already exists');

// createUser rejects blocked and disposable email domains with this message.
export const ErrEmailDomainNotAllowed = new Error('Email domain not allowed to sign up');

export const ErrAddressAlreadyTaken = new Error('GraphQL Error: address already taken');
